import * as React from 'react';
import Box from '@mui/material/Box';
import { Paper, Grid } from '@mui/material';
import { Directions } from '@mui/icons-material';

export default function MyPageContainer( {containedComponent}) {
  return (
    <Grid container direction="column" padding={2} >
      <Paper elevation={3}
        sx={{
          display: 'flex',
          bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
          color: (theme) =>
            theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
          border: '1px solid',
          borderColor: (theme) =>
            theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
          borderRadius: 2,
          fontSize: '0.875rem',
          fontWeight: '700',
          alignContent:'center',
          justifyContent:'center',
          
          width:'100%'
        }}
      >
        {containedComponent}
      </Paper>
    </Grid>
  );
}
